import { ConfigProvider, DatePicker } from 'antd';
import type { DatePickerProps } from 'antd';
import { useSelector } from 'react-redux';
import { RootState } from '../../rootReducer';

/**
 * AntD DatePicker themed with the merchant's brand colour so the calendar
 * (selected day, "today" outline, hover, and input focus ring — all driven by
 * AntD's `colorPrimary` token) matches the rest of the merchant style guide,
 * exactly as `Forms/FormView` themes its AntD form. Falls back to AntD's
 * default when no custom theme is set.
 */
export default function ThemedDatePicker(props: DatePickerProps) {
  const sourceColor = useSelector<RootState, string | undefined>(
    state => state.restaurant.profile?.custom_theme?.sourceColor,
  );

  return (
    <ConfigProvider theme={{ token: { colorPrimary: sourceColor } }}>
      <DatePicker {...props} />
    </ConfigProvider>
  );
}
